<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5236 21.0707V16.5519C12.5236 15.9124 13.0441 15.394 13.6746 15.394C14.165 15.394 14.7255 15.394 15.2159 15.394C15.8564 15.394 16.3669 15.9124 16.3669 16.5519V21.0707H17.4578C18.0182 21.0707 18.5487 20.8495 18.949 20.4552C19.3393 20.0608 19.5595 19.5264 19.5595 18.9699V10.9683H19.7897C20.3902 10.9683 20.9206 10.5729 21.0908 9.99546C21.2709 9.41798 21.0407 8.79446 20.5403 8.46119C20.5403 8.46119 18.939 7.3978 18.2784 6.95933V4.57314C18.2784 3.87766 17.718 3.31389 17.0174 3.31389H16.1066C15.7663 3.31389 15.4461 3.4466 15.2159 3.6828C14.9757 3.919 14.8456 4.23937 14.8456 4.57345V4.67963C14.175 4.23606 13.4044 3.72664 13.4044 3.72644C12.5537 3.16287 11.4528 3.16287 10.602 3.72644C8.93066 4.83937 5.6279 7.0317 3.4661 8.46119C2.96569 8.79446 2.7455 9.41798 2.91564 9.99546C3.09579 10.5729 3.62624 10.9683 4.22674 10.9683H4.47695C4.47695 12.5466 4.47695 16.7251 4.47695 18.9699C4.47695 19.5264 4.69713 20.0608 5.09746 20.4552C5.48779 20.8495 6.01823 21.0707 6.5787 21.0707H12.5236ZM10.4319 13.3523C10.4319 12.8648 10.0316 12.4705 9.55117 12.4705C9.14083 12.4705 8.65042 12.4705 8.24008 12.4705C7.74967 12.4705 7.34934 12.8648 7.34934 13.3523V14.6653C7.34934 15.1528 7.74967 15.5481 8.24008 15.5481C8.65042 15.5481 9.14083 15.5481 9.55117 15.5481C10.0316 15.5481 10.4319 15.1528 10.4319 14.6653V13.3523Z"
      fill="#3CA091"
    />
  </svg>
</template>

<script>
export default {
  name: 'HomeSelected'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
